var _style, _g, _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:none;fill:#F4F7FA;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{opacity:0.66;fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_3_);}\r\n\t.st5{opacity:0.33;fill:url(#SVGID_4_);}\r\n\t.st6{fill:url(#SVGID_5_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1809.3,
    cy: 1829.3,
    r: 1316.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 836.3559,
    y1: 2174.6648,
    x2: 2782.2312,
    y2: 2174.6648
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M836.4,2476.3c0,0,1368.2,1033.7,1945.9-881.7c-60.8,91.2-608.1,912.1-1033.7,760.1 c243.2-121.6,547.3-395.3,425.7-699.3C1839.7,2172.2,1353.2,1989.8,836.4,2476.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1748.6849,
    y1: 1612.3857,
    x2: 3268.8999,
    y2: 1612.3857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1779.1,1412.1c56.9,16.5,108.4,33.9,154.2,52.3c28.1,11.1,56.9,23.9,84.6,38.7 c83,43.8,136.9,93.7,156.4,152.2c121.6,304-182.4,577.7-425.7,699.3c425.7,152,972.9-668.9,1033.7-760.1 c121.6-456.1,486.5-486.5,486.5-486.5v-0.7C3236.7,1058.8,2732.9,398.7,1779.1,1412.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.1,
    y1: 2406.304,
    x2: 2782.2312,
    y2: 2406.304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M2782.2,1615.8c-577.7,1915.5-1945.9,881.7-1945.9,881.7C554.9,2799,549,2974.6,441.1,3196.8 C897.2,2923.2,2721.4,3470.5,2782.2,1615.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 501.9,
    y1: 1316.6605,
    x2: 1778.8806,
    y2: 1316.6605
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1778.9,1412.1c-190.1-56.6-406.7-134.5-638.5-243.2c-251.5-118-464.3-245.8-638.5-364.9v912.1 C866.8,2020.2,1550.8,1640.1,1778.9,1412.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 501.9086,
    y1: 1944.1814,
    x2: 2174.1453,
    y2: 1944.1814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M501.9,1716.1c0,0,0,425.7,334.4,760.1c516.9-486.5,1003.3-304,1337.8-820.9 c-26.6-66.5-88.1-115.5-156.4-152.2c-25.5-13.5-53.8-26.3-84.6-38.7c-61.2-24.3-119-40.6-154.2-52.3 C1550.9,1640.1,866.8,2020.2,501.9,1716.1z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.1265205304bbee4f5311a616d14fae45.svg";
export { ForwardRef as ReactComponent };